function formatDate(): string {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}`;
}

function logObject<T = unknown>(label: string, feature: string, obj: T, color: string): void {
  console.groupCollapsed(`%c[${formatDate()}] [${label}] - ${feature}`, `color: ${color}; font-weight: bold;`);
  if (obj && typeof obj === 'object') {
    Object.entries(obj as Record<string, unknown>).forEach(([key, value]) => {
      console.log(`%c${key}:`, 'color: gray; font-weight: bold;', value);
    });
  } else {
    console.log('%cValue:', 'color: gray; font-weight: bold;', obj);
  }
  console.groupEnd();
}

export function logConsoleAction<T = unknown>(feature: string, action: T): void {
  logObject('ACTION', feature, action, '#5260ff');
}

export function logConsoleError<T = unknown>(feature: string, error: T): void {
  logObject('ERROR', feature, error, '#e53935');
}

export function logConsoleInfo<T = unknown>(feature: string, info: T): void {
  logObject('INFO', feature, info, '#fbc02d');
}

export function logConsoleSuccess<T = unknown>(feature: string, success: T): void {
  logObject('SUCCESS', feature, success, '#6dc55c');
}

export function logConsoleState<T = unknown>(feature: string, state: T): void {
  logObject('STATE', feature, state, '#5260ff');
}